import { CREDENTIAL_FORM_DESCRIPTORS } from "@api/shared-runtime/credential-form-descriptors";
import { CredentialType } from "@api/shared-runtime/enums";
import { LifeSupportKind } from "@api/shared-runtime/credential-vocabularies";
import type { Credential } from "../types";

/** Life-support instances are identified by their recorded subtype. Add forms
 * use the current draft so a newly selected or parsed certification is named
 * immediately; existing credentials retain their locked saved identity. */
export function credentialDisplayLabel({
  credential,
  draftCertKind,
}: {
  credential: Credential;
  draftCertKind?: string | boolean;
}): string {
  if (credential.credentialType !== CredentialType.LifeSupport) {
    return credential.label;
  }
  const details = credential.version?.details as
    | Record<string, unknown>
    | null
    | undefined;
  let certKind = details?.certKind;
  if (!credential.present && draftCertKind !== undefined) {
    certKind = draftCertKind;
  }
  if (typeof certKind !== "string") {
    return credential.label;
  }

  const normalized = certKind.trim().toLowerCase();
  const option = CREDENTIAL_FORM_DESCRIPTORS[CredentialType.LifeSupport].fields
    .find((field) => field.key === "certKind")
    ?.options?.find((entry) => entry.value === normalized);
  if (!option) {
    return credential.label;
  }
  if (option.value === LifeSupportKind.Other) {
    return "Other life support certification";
  }
  return `${option.label} certification`;
}
